
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { personalizedName } from '../../selectors/journeyState-selectors'
import { resetToHome } from '../../actions/journey-actions'
import Hammer from "react-hammerjs";
import { tapOptions } from '../../utils/hammerOptions';
import createAnother from '../../assets/btn_createAnother.png'

const JourneyDone = ({ personalizedName, resetToHome, galleryId }) => (
   <div className={'journey-content-container journey-print-container'}>
      <div className={'bordered-container title'} style={{width: '60%', marginTop: '13%'}}>
         <div className={'large-3 border'}>
            Great Job <strong>{personalizedName}</strong>!<br/>
            Your ART HUNT is now printing at the <br/>Front Visitor Service Desk
         </div>
      </div>
      <div className={'bottom-button-group'}>
         <Hammer onTap={() => resetToHome(galleryId)} options={tapOptions} >
            <img src={createAnother} alt={'Create Another'} />
         </Hammer>
      </div>
   </div>
)

const mapStateToProps = (state, ownProps) => {
   return {
      personalizedName: personalizedName(state, ownProps),
     ...ownProps
   }
}
const mapDispatchToProps = dispatch => bindActionCreators({
   resetToHome,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JourneyDone)


// WEBPACK FOOTER //
// ./src/components/FinalizeJourney/JourneyDone.js